import { render, staticRenderFns } from "./QuoteForm.vue?vue&type=template&id=64040494&scoped=true"
import script from "./QuoteForm.vue?vue&type=script&lang=js"
export * from "./QuoteForm.vue?vue&type=script&lang=js"
import style0 from "./QuoteForm.vue?vue&type=style&index=0&id=64040494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64040494",
  null
  
)

export default component.exports